export default {
  title: 'Mediasbox',
  description: 'Manage your files and media',
  analytics: {
    title: 'Asset Analytics',
  },
  workspaces: {
    title: 'Workspaces',
    spaces: 'spaces',
    create: 'Create workspace',
    search: 'Search workspaces...',
    toggleCompact: 'Toggle compact view',
    expand: 'Expand sidebar',
    
    // Storage
    storage: 'Storage Usage',
    storageInfo: 'Videos are counted in hours • Other files in GB',
    details: 'Details',
    videoStorage: 'Video Storage',
    otherStorage: 'Other Files',
    globalUsage: 'Overall Usage',
    includingRenditions: 'including all qualities',
    videoEquivalent: '~{size} of storage',
    good: 'Good',
    high: 'High', 
    critical: 'Critical',
    storageGood: 'Good',
    storageHigh: 'High',
    storageCritical: 'Critical',
    storageDetails: 'Storage Details',
    overallUsage: 'Overall Usage',
    totalStorage: 'Total Storage',
    usedStorage: 'Used Storage',
    availableStorage: 'Available',
    storageCriticalMessage: 'You are running out of storage space!',
    storageHighMessage: 'Your storage is getting full.',
    upgradePlan: 'Upgrade Plan',
    byFileType: 'By File Type',
    topWorkspaces: 'Top Workspaces',
    
    // Navigation
    overview: 'Overview',
    favorites: 'Favorites',
    recent: 'Recent',
    all: 'All Workspaces',
    searchResults: 'Search Results',
    
    // Stats
    empty: 'Empty',
    file: 'file',
    files: 'files',
    oneFile: '1 file',
    multipleFiles: '{count} files',
    used: 'Used',
    
    // Actions
    favorite: 'Add to favorites',
    unfavorite: 'Remove from favorites',
    pin: 'Pin workspace',
    unpin: 'Unpin workspace',
    pinned: 'Pinned',
    shared: 'Shared workspace',
    private: 'Private workspace',
    moreActions: 'More actions',
    edit: 'Edit workspace',
    duplicate: 'Duplicate',
    share: 'Share',
    export: 'Export',
    archive: 'Archive',
    unarchive: 'Unarchive',
    delete: 'Delete',
    
    // Time
    justNow: 'Just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    
    // Empty state
    emptyState: {
      title: 'No workspaces yet',
      description: 'Create your first workspace to start organizing your files',
      action: 'Create first workspace'
    },
    
    // Search
    noResults: 'No workspaces found for "{query}"',
    
    // File types
    videos: 'Videos',
    images: 'Images',
    documents: 'Documents',
    audio: 'Audio',
    other: 'Other',
    
    // Storage Details Dialog
    storageExplanation: 'Video storage is measured in hours to include all quality renditions. Other files are measured in GB.',
    videoStorageTitle: 'Video Storage',
    otherFilesTitle: 'Other Files Storage',
    ofVideo: 'of video',
    totalDuration: 'Total Duration',
    estimatedSize: 'Estimated Disk Usage',
    videoCount: 'Video Files',
    renditions: 'Quality Renditions',
    included: 'Included',
    fileDistribution: 'File Type Distribution',
    workspaceBreakdown: 'Workspace Breakdown',
    byVideoDuration: 'By Video Duration',
    byStorageSize: 'By Storage Size'
  },
  upload: {
    button: 'Upload',
    dragDrop: 'Drag and drop files here',
    or: 'or',
    browse: 'Browse files',
    uploading: 'Uploading...',
    success: 'File uploaded successfully',
    error: 'Upload failed'
  },
  file: {
    name: 'Name',
    size: 'Size',
    type: 'Type',
    modified: 'Modified',
    created: 'Created',
    actions: 'Actions',
    download: 'Download',
    rename: 'Rename',
    move: 'Move',
    copy: 'Copy',
    share: 'Share',
    delete: 'Delete',
    preview: 'Preview',
    info: 'Info'
  },
  move: {
    title: 'Move {count} item | Move {count} items',
    currentLocation: 'Current location',
    action: 'Move',
    success: 'Successfully moved {count} item | Successfully moved {count} items',
    error: 'Failed to move items'
  },
  folder: {
    create: 'New folder',
    name: 'Folder name',
    empty: 'This folder is empty',
    root: 'Root',
    path: 'Path',
    enterName: 'Enter folder name',
    items: 'item | items'
  },
  createFolder: 'Create folder',
  createFolderDescription: 'Organize your files',
  createCollection: 'Create collection',
  createCollectionDescription: 'Group related assets',
  uploadFile: 'Upload files',
  uploadFileDescription: 'Add new content',
  workspace: {
    select: 'Select workspace'
  },
  types: {
    folder: 'Folder',
    file: 'File',
    video: 'Video',
    image: 'Image',
    audio: 'Audio',
    document: 'Document',
    archive: 'Archive',
    collection: 'Collection',
    other: 'Other'
  },
  search: {
    placeholder: 'Search folders...',
    placeholderAssets: 'Search files and folders...',
    noResults: 'No results found'
  },
  filter: {
    title: 'Filters',
    type: 'File type',
    recent: 'Recent',
    favorites: 'Favorites',
    hasMedia: 'Contains media',
    empty: 'Empty folders',
    clear: 'Clear all',
    images: 'Images',
    videos: 'Videos',
    documents: 'Documents',
    audio: 'Audio files'
  },
  sort: {
    title: 'Sort by',
    name: 'Name',
    modified: 'Last modified',
    size: 'Item count'
  },
  space: {
    title: 'Spaces',
    create: 'Create space',
    name: 'Space name',
    description: 'Description',
    defaultSpace: 'Default space'
  },
  view: {
    grid: 'Grid view',
    list: 'List view',
    sortBy: 'Sort by',
    filterBy: 'Filter by'
  },
  selection: {
    selected: '{count} selected',
    selectAll: 'Select all',
    deselectAll: 'Deselect all'
  },
  confirmDelete: {
    title: 'Delete {type}?',
    message: 'Are you sure you want to delete "{name}"?',
    messageMultiple: 'Are you sure you want to delete {count} items?',
    permanentWarning: 'This action cannot be undone.'
  },
  select: {
    title: 'Select Asset',
    action: 'Select',
    items: 'item | items',
    emptyFolder: 'This folder is empty',
    preview: 'Preview',
    duration: 'Duration'
  },
  video: {
    trim: {
      title: 'Trim Video',
      newLength: 'New video length',
      startTime: 'Start time',
      endTime: 'End time',
      setStart: 'Set start',
      setEnd: 'Set end',
      reset: 'Reset to original'
    },
    capture: {
      title: 'Capture Frame',
      preview: 'Captured Frame',
      noCapture: 'No frame captured yet',
      captureButton: 'Capture Current Frame',
      format: 'Image Format',
      quality: 'Quality',
      filename: 'Filename',
      info: '{width}x{height} at {time}'
    }
  },
  settings: {
    foldersDisplay: 'Folders Display',
    foldersDisplayHint: 'Control how folders are displayed in the view.',
    flattenFolders: 'Hide folders (flat view)'
  }
}
